export default "﻿<div class=\"TiRouteSections\">\n    <div data-dojo-attach-point=\"mainContainer\"\n         class=\"\">\n\n    </div>\n</div>\n"